import { useState, useCallback, useEffect } from 'react';
import { getMyShipments } from 'api/shipment';
import { SHIPMENT_STATUS } from 'domain/shipment/shipment.constants';

// api/shipment's getMyShipments returns AxiosResponse<unknown> — no src/contracts/ schema is
// validated at this layer (see docs/PENDING-FINDINGS.md, the api/shipment.ts conversion), so
// this defensive read of either shape is typed from evidence, not invented (AGENTS.md §1) —
// same pattern already established for features/dashboard/queries.ts.
interface ShipmentLike {
  status?: string;
}

interface ShipmentsListPayload {
  data?: ShipmentLike[];
  results?: ShipmentLike[];
}

const useShipmentQuotingCount = () => {
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await getMyShipments();
      const payload = res?.data as ShipmentLike[] | ShipmentsListPayload | undefined;
      const shipments: ShipmentLike[] = Array.isArray(payload) ? payload : payload?.data || payload?.results || [];
      setCount(shipments.filter((s) => s.status === SHIPMENT_STATUS.QUOTING).length);
    } catch {
      setCount(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { count, loading, refresh };
};

export default useShipmentQuotingCount;
